import React from "react";
import { Card, CardContent, Link, Stack, Typography } from "@mui/material";

const evidenceClaims = (evidence) =>
  [
    evidence?.primaryFact?.claim,
    ...(Array.isArray(evidence?.allowedClaims) ? evidence.allowedClaims : []),
  ].filter((claim, index, claims) => claim && claims.indexOf(claim) === index);

const EvidencePanel = ({ evidence = {}, capturedAt }) => (
  <Card component="aside" variant="outlined">
    <CardContent>
      <Stack spacing={1.5}>
        <Typography variant="h6" fontWeight={800}>
          Frozen evidence
        </Typography>
        {evidenceClaims(evidence).map((claim) => (
          <Typography key={claim}>{claim}</Typography>
        ))}
        {capturedAt && (
          <Typography
            component="time"
            dateTime={capturedAt}
            color="text.secondary"
            variant="body2"
          >
            Captured {new Date(capturedAt).toLocaleString()}
          </Typography>
        )}
        {evidence.destinationUrl && (
          <Link href={evidence.destinationUrl}>{evidence.destinationUrl}</Link>
        )}
      </Stack>
    </CardContent>
  </Card>
);

export default EvidencePanel;
